import { createApp } from 'vue'; // Vue 3のアプリケーション作成
import App from './App.vue'; // ルートコンポーネント
import router from './router'; // Vue Routerの設定
import scrollAnimation from './directives/scrollAnimation.js';
import rellax from './directives/rellax.js';
import './assets/styles/global.css'; // グローバル CSS をインポート
import { VueMasonryPlugin } from "vue-masonry";

// アプリケーションの初期化
const app = createApp(App);

// プラグインの登録
app.use(router); // Vue Routerを登録
app.use(VueMasonryPlugin);

// カスタムディレクティブを登録
app.directive('scroll-animation', scrollAnimation);
app.directive('rellax', rellax);

// アプリケーションのマウント
app.mount('#app'); // HTMLの<div id="app">にマウント




